import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Toolbar as MuiToolbar } from '@mui/material';

export const Toolbar = forwardRef(({ className, children, style }, ref) => (
  <MuiToolbar
    className={className}
    style={style}
    sx={{
      minHeight: 60,
      paddingLeft: 32,
      paddingRight: 32,
    }}
    ref={ref}
  >
    {children}
  </MuiToolbar>
));

Toolbar.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};
